var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapMarkers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.913 6.70157C16.913 10.4027 9.95652 20 9.95652 20C9.95652 20 3 10.4027 3 6.70157C3 3.0004 6.11454 0 9.95652 0C13.7985 0 16.913 3.0004 16.913 6.70157Z",
    fill: "#888888"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.22875 9.79426H8.2168L10.8433 3.91162L12.5371 4.66887L9.91065 10.5475H9.89869L8.28057 11.9265L8.22875 9.79426Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9572 2.65207L12.7304 2.99881C12.9855 3.11041 13.0971 3.40932 12.9855 3.6644L12.6587 4.39375L10.9648 3.6365L11.2917 2.90715C11.4033 2.65207 11.7022 2.54048 11.9572 2.65207V2.65207Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarkers);
export default __webpack_public_path__ + "static/media/mapMarkers.04f8d46353ffe29a1848f9789b720059.svg";
export { ForwardRef as ReactComponent };